<ng-container *ngIf="activeAudioCallUiService.minimized$ | async">
  <div *ngIf="shouldShow"
       class="active-call-widget"
       [class.active-call-widget--video]="hasRemoteVideo"
       [class.active-call-widget--native-pip]="activeAudioCallNativeService.isNativePictureInPictureActive$ | async"
       cdkDrag
       cdkDragBoundary="ion-app"
       role="button"
       tabindex="0"
       (click)="openFullCallFromPointer()"
       (pointerdown)="resetPointerOpenSuppression()"
       (cdkDragEnded)="onWidgetDragEnded($event)"
       (keyup.enter)="openFullCall()"
       (keyup.space)="openFullCall()">
    <audio #audioOutput class="active-call-widget__audio" autoplay></audio>

    <video #remoteVideo
           class="active-call-widget__video"
           [class.active-call-widget__video--hidden]="!hasRemoteVideo"
           autoplay
           playsinline
           muted>
    </video>

    <div *ngIf="!hasRemoteVideo" class="active-call-widget__fallback">
      <div class="active-call-widget__avatar">
        <user-avatar [fullName]="partnerFullName"
                     [avatarUrl]="partnerAvatarUrl">
        </user-avatar>
      </div>
      <ion-icon class="active-call-widget__fallback-icon" name="call-outline"></ion-icon>
    </div>

    <div class="active-call-widget__meta">
      <div *ngIf="partnerFullName" class="active-call-widget__name">{{ partnerFullName }}</div>
      <ng-container *ngIf="connectAudioService.inStream && (connectAudioService.webrtcAudioService.isConnected$ | async) && (connectAudioService.streamTime$ | async) as time; else callStatus">
        <div class="active-call-widget__status">{{ time }}</div>
      </ng-container>
      <ng-template #callStatus>
        <div class="active-call-widget__status">{{ callStatusKey | translate }}</div>
      </ng-template>
    </div>
  </div>
</ng-container>
